@if (ejTreeFieldsConfig) {
    <div class="cerrix-tree-viewer">
        <ejs-treeview
            id="default"
            [fields]="ejTreeFieldsConfig"
            [allowDragAndDrop]="config.allowDragDrop"
            (nodeSelected)="onSelect($event)"
            (nodeDropped)="onDrop($event)"
            #treeViewComp
        >
            <ng-template #nodeTemplate="" let-data="">
                <div class="tree-node">
                    @if (config.iconProperty) {
                        <div class="tree-node-icon">
                            <cerrix-icon-viewer [icon]="data.Icon"></cerrix-icon-viewer>
                        </div>
                    }
                    <div class="tree-node-text">
                        {{ data.Name }}
                    </div>
                </div>
            </ng-template>
        </ejs-treeview>
    </div>
}
